import React from 'react'
import { BsLinkedin } from 'react-icons/bs'
import { FaGithub, FaDribbble } from 'react-icons/fa'
import { FiDribbble } from 'react-icons/fi'

function HeaderSocials() {
  return (
    <div className='header__socials'>
      <a
        href='https://linkedin.com/mamt4real'
        rel='noreferer'
        target={'_blank'}
      >
        <BsLinkedin />
      </a>
      <a href='https://github.com/mamt4real' rel='noreferer' target={'_blank'}>
        <FaGithub />
      </a>
      <a href='https://dribble.com/mamt4real' rel='noreferer' target={'_blank'}>
        <FiDribbble />
      </a>
    </div>
  )
}

export default HeaderSocials
